import type { ReactNode } from 'react';
import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { StickyCtaBar } from '../../components/StickyCtaBar';
import CustomizerLayoutSidePanel from '../../components/CustomizerLayoutSidePanel';
import { useTranslation } from '@shared/core';

export const CardFrontConfigPanel = ({
  hideStickyCtaBar,
  renderCustomizations,
  onNext,
  allowOrderEdit,
  nextStepLabel,
}: {
  hideStickyCtaBar: boolean;
  renderCustomizations: () => ReactNode;
  onNext: () => void;
  allowOrderEdit?: boolean;
  nextStepLabel: string;
}) => {
  const { tq } = useTranslation('stationery');

  return (
    <CustomizerLayoutSidePanel
      title={tq`Edit Front`}
      withBlur={hideStickyCtaBar}
      allowOrderEdit={allowOrderEdit}
    >
      {renderCustomizations()}
      {!hideStickyCtaBar && (
        <StickyCtaBar>
          <ButtonV2
            fullWidth={true}
            intent="neutral"
            shape="rounded"
            onClick={onNext}
          >
            {tq`Next: ${nextStepLabel}`}
          </ButtonV2>
        </StickyCtaBar>
      )}
    </CustomizerLayoutSidePanel>
  );
};
